import { useEffect, useRef } from 'react'
import { useI18n } from '../lib/i18n'
import { useToast } from './Toast'

export function SectionRefresh({ refreshing, failed }: {
  refreshing: boolean
  failed: boolean
}) {
  const { t } = useI18n()
  const { showToast } = useToast()
  const wasFailed = useRef(false)
  useEffect(() => {
    if (failed && !wasFailed.current) showToast(t('common.refreshFailed'), 'error')
    wasFailed.current = failed
  }, [failed, showToast, t])

  // The toolbar button shows progress visually. Announce updates without
  // adding a row or reserving space above the content.
  return (
    <span className="dash-sr-only" role="status" aria-live="polite">
      {refreshing ? t('common.refreshingData') : ''}
    </span>
  )
}
